// extracted by mini-css-extract-plugin
module.exports = {"container":"public_container_2-R6Y","bodyContainer":"public_bodyContainer_2Us8n"};